import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container } from '@mui/material';
import UnifiedHeader from './UnifiedHeader';
import Footer from './Footer';
import { useAuth } from '../../context/AuthContext';

const Layout = ({ children }) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isAdmin = user && user.is_admin >= 1;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Box
        component="a"
        href="#main-content"
        sx={{
          position: 'absolute',
          top: -9999,
          left: 0,
          zIndex: 9999,
          p: 1,
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          fontWeight: 600,
          borderRadius: '0 0 4px 0',
          '&:focus': { top: 0 },
        }}
      >
        {t('nav.skipToContent')}
      </Box>

      <UnifiedHeader />

      {/* overflowX clip: full-bleed sections (homepage hero) use 100vw breakout;
          clipping at the full-width main element prevents scrollbar-width overflow */}
      <Box
        id="main-content"
        component="main"
        tabIndex={-1}
        sx={{ flexGrow: 1, py: { xs: 2, sm: 3, md: 4 }, overflowX: 'clip' }}
      >
        <Container maxWidth="xl">
          {children}
        </Container>
      </Box>

      <Footer isAdmin={isAdmin} />
    </Box>
  );
};

export default Layout;
